import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'app-fnf-base-dialog',
  imports: [CommonModule],
  templateUrl: './fnf-base-dialog.html',
  styleUrl: './fnf-base-dialog.scss',
})
export class FnfBaseDialog {
  visible = input<boolean>(false);
  subject = input<string>('');
  class = input<string>('');
  onClose = output<void>();

  dialogCardClass = computed(() => {
    const base = 'fnf-dialog-card';
    const custom = this.class() ?? '';
    return `${base} ${custom}`.trim();
  });

  close(): void {
    this.onClose.emit();
  }
}
